import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail, MessageSquare, Lightbulb } from "lucide-react";
import { ASSETS } from "@/lib/assets";

const PHONE = "07903 375399";
const PHONE_TEL = "+447903375399";
const EMAIL = "kingleonidas116@gmail.com";

export default function Contact() {
  return (
    <div className="min-h-screen relative">
      <div className="absolute inset-0 z-0">
        <img src={ASSETS.hero} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0"
             style={{ background: "linear-gradient(180deg, rgba(3,3,3,0.85), rgba(3,3,3,0.97))" }} />
      </div>

      <div className="relative z-10 max-w-[920px] mx-auto px-6 sm:px-8 lg:px-12 py-10 lg:py-20">
        <Link to="/" className="btn-ghost inline-flex items-center gap-2"
              data-testid="contact-back-link">
          <ArrowLeft className="w-3 h-3" /> RETURN
        </Link>

        <div className="mt-12 fade-up">
          <p className="tac-label">SPEAK WITH THE BUILDER</p>
          <h1 className="font-serif-h text-5xl lg:text-7xl uppercase text-bone leading-none mt-3"
              data-testid="contact-heading">
            Get In<br /><span className="text-blood">Touch.</span>
          </h1>
          <p className="text-base text-[var(--text-main)] max-w-2xl mt-6 leading-relaxed">
            Queries, concerns, feedback, or even tips on how to make this app sharper —
            I'd love to hear from you. The lines below are mine, personally.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 fade-up delay-1">
          <a href={`tel:${PHONE_TEL}`}
             className="tactical-card p-6 hover:border-blood transition-all block group"
             data-testid="contact-phone-link">
            <Phone className="w-6 h-6 text-blood" strokeWidth={1.5} />
            <p className="tac-label mt-4">PHONE</p>
            <p className="font-serif-h text-2xl text-bone mt-1 group-hover:text-blood transition-colors"
               data-testid="contact-phone-number">
              {PHONE}
            </p>
            <p className="text-xs text-muted-h mt-3 leading-relaxed">
              UK number. Tap to call. Voicemail if I can't pick up — I will get back to you.
            </p>
          </a>

          <a href={`mailto:${EMAIL}?subject=Zombie%20Usurper`}
             className="tactical-card p-6 hover:border-blood transition-all block group"
             data-testid="contact-email-link">
            <Mail className="w-6 h-6 text-blood" strokeWidth={1.5} />
            <p className="tac-label mt-4">EMAIL</p>
            <p className="font-serif-h text-xl text-bone mt-1 break-all group-hover:text-blood transition-colors"
               data-testid="contact-email-address">
              {EMAIL}
            </p>
            <p className="text-xs text-muted-h mt-3 leading-relaxed">
              The most reliable channel. Tap to compose. I read everything.
            </p>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 fade-up delay-2">
          <Reason icon={MessageSquare} title="QUERIES & CONCERNS"
                  body="Bug reports, account issues, billing questions about supporting the app, anything about the game world." />
          <Reason icon={Lightbulb} title="TIPS & IDEAS"
                  body="Got a mechanic you wish existed? A feature that would make it click? Drop it in. Most player suggestions get built." />
        </div>

        <div className="mt-10 narrative-panel fade-up delay-3" data-testid="contact-footer">
          <p className="text-[0.7rem] text-muted-h leading-relaxed">
            Built and maintained by Samuel Stewart. London, 2026. Replies usually within
            48 hours. Be patient with me — the horde keeps me busy.
          </p>
        </div>
      </div>
    </div>
  );
}

const Reason = ({ icon: Icon, title, body }) => (
  <div className="tactical-card p-5">
    <Icon className="w-5 h-5 text-blood" strokeWidth={1.5} />
    <p className="tac-label mt-3">{title}</p>
    <p className="text-xs text-[var(--text-main)] mt-2 leading-relaxed">{body}</p>
  </div>
);
